import React from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { Row, Col, Button, Breadcrumb } from 'react-bootstrap';
import AlertApprovalAccordian from './alertsApprovalAccordion';
import Modal4DenyAlert from '../../../components/modals/Modal4DenyAlert';
import Modal4ApproveAlert from '../../../components/modals/Modal4ApproveAlert';
import Modal4DenyAllAlert from '../../../components/modals/Modal4DenyAllAlert';
import Modal4ApproveAllAlert from '../../../components/modals/Modal4ApproveAllAlert';
import { useApprovalAlerts } from './useApprovalAlerts';
import { selector as approvaeAlertApi } from './approveAlertSlice';
import { selector as denyAlertApi } from './denyAlertSlice';
import { routes } from '../../../common/constants';
import './alertsneedingapproval.scss';

const AlertsNeedingApproval = () => {
  const {
    data,
    denyPop,
    setDenyPop,
    approvePop,
    setApprovePop,
    selectedAlert,
    handleDenyClick,
    handleApproveClick,
  } = useApprovalAlerts();
  const denyAlertApiResponse = useSelector(denyAlertApi);
  const approvaeAlertApiResponse = useSelector(approvaeAlertApi);

  return (
    <div className='alertsApproval_container'>
      <Col>
        <div className='alertApproval_header'>
          <div className='alertApproval_heading'>
            <h1>Approve Alerts</h1>
          </div>
          <div className='alertApproval_action'>
            {data?.length > 0 ? <Modal4DenyAllAlert data={data} /> : null}
            {data?.length > 0 ? <Modal4ApproveAllAlert data={data} /> : null}
            {denyPop && (
              <Modal4DenyAlert setDenyPop={setDenyPop} alert={selectedAlert} />
            )}
            {approvePop && (
              <Modal4ApproveAlert
                setApprovePop={setApprovePop}
                alert={selectedAlert}
              />
            )}
          </div>
        </div>
      </Col>
      <Col sm={6}>
        <div className='alertsApproval_breadcrumbs'>
          <Breadcrumb>
            <Breadcrumb.Item
              linkAs={Link}
              linkProps={{ to: `${routes.alerts}` }}
            >
              Alerts
            </Breadcrumb.Item>
            <Breadcrumb.Item active>Approve Alerts</Breadcrumb.Item>
          </Breadcrumb>
        </div>
      </Col>

      {data?.length === 0 ? (
        <Col className='alertApprovalAccordion_container'>
          No Alerts are there for Deny/Approval
        </Col>
      ) : null}
      <Col className='alertApprovalAccordion_container'>
        {data?.map((item, index) => (
          <Row key={index}>
            <Col sm={10}>
              <div className='alertsApproval_accordian'>
                <AlertApprovalAccordian item={item} />
              </div>
            </Col>
            <Col sm={2}>
              <div className='alertsApprovalAction_btns'>
                <Button
                  onClick={() => {
                    handleDenyClick(item);
                  }}
                >
                  Deny
                </Button>
                <Button
                  onClick={() => {
                    handleApproveClick(item);
                  }}
                >
                  Approve
                </Button>
              </div>
            </Col>
          </Row>
        ))}
      </Col>
    </div>
  );
};

export default AlertsNeedingApproval;
